import axios from "axios";

export const state = {
    reportpharmacypurchases: [],
};

export const getters = {
    reportpharmacypurchases: state => state.reportpharmacypurchases,
};

export const mutations = {
    setReportPharmacyPurchases(reportpharmacypurchases, newValue) { state.reportpharmacypurchases = newValue},
};

export const actions = {
    fetchReportPharmacyPurchases({ commit }) {
        axios.get('/reportpharmacypurchases').then(res => {
            commit('setReportPharmacyPurchases', res.data.purchases)
        })
    },
    filterReportPharmacyPurchases({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpharmacypurchases";
        axios.post(url, formData).then((response) => {
            commit('setReportPharmacyPurchases', response.data.purchases)
        })
    },
};
